import { Table } from '@octano/global-ui';
import { SectionTitle } from '../../../../components/text';
import { PaymentInfo } from '../../types';
import { useColumns } from './hooks/useColumns';

type Props = {
  data: PaymentInfo;
  loading: boolean;
  readOnly?: boolean;
  onSend: () => void;
  onRefresh: () => void;
  texts: {
    title: string;
    table: {
      noResults: string;
      headers: {
        concept: string;
        amount: string;
        paymentDate: string;
        status: string;
        action: string;
      };
      values: {
        concept: string;
        payment: { pending: string; paid: string };
        actions: { send: string; update: string; paid: string };
      };
    };
  };
};

export function PaymentStatus({
  data,
  loading,
  readOnly,
  onSend,
  onRefresh,
  texts,
}: Props) {
  const columns = useColumns(texts.table, {
    provider: data?.provider ?? null,
    loading,
    readOnly,
    onSend,
    onRefresh,
  });
  const tableData = data ? [data] : [];
  return (
    <>
      <SectionTitle text={texts.title} />
      <Table columns={columns} data={tableData} noResultsText={texts.table.noResults} />
    </>
  );
}
